import { AlertTriangle, RefreshCw } from 'lucide-react'
import { Button } from './Button'

export function QueryError({
  title = 'Couldn’t load this data',
  error,
  onRetry,
}: {
  title?: string
  error?: unknown
  onRetry: () => void
}) {
  const detail = error instanceof Error ? error.message : 'Check the connection and try again.'
  return (
    <div className="admin-query-error" role="alert">
      <AlertTriangle aria-hidden="true" />
      <div>
        <strong>{title}</strong>
        <p>{detail}</p>
        <Button type="button" size="sm" variant="secondary" onClick={onRetry}>
          <RefreshCw aria-hidden="true" className="h-3.5 w-3.5" /> Try again
        </Button>
      </div>
    </div>
  )
}
